export var isBodyEmpty = function (html) {
    return html.replace(/<[^>]*>/g, "").trim().length === 0;
};
export var htmlToPlainText = function (html) {
    return html
        .replace(/<\/(p|div|h[1-6]|li)>/gi, "\n")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
};
